import {LoadingSpinner} from "../comboBox/ComboBox";
import React from "react";
import {FloatingPortal} from "@floating-ui/react";

// da https://stackoverflow.com/questions/65749715/div-on-top-of-another-with-tailwind-css e
// https://play.tailwindcss.com/h0BmHTW9KQ

interface LoadingProps {
    children: React.ReactNode,
    spinner?: React.ReactNode,
    loading: boolean,
    background?: boolean,
    className?: string,
}

const Loading: React.FC<LoadingProps> = ({loading, children, background = true, spinner = <LoadingSpinner/>, className = "relative z-0"}) => {
    return <div className={className}>
        {children}
        {(false || loading) && <>
            <FloatingPortal>
                {background && <div className="oscura absolute inset-0 rounded-lg w-full h-full z-40"></div>}
                <div className="absolute inset-0 flex justify-center items-center z-50">
                    {spinner}
                </div>
            </FloatingPortal>
        </>}
    </div>
};
export default Loading;